import {AnyAction} from 'redux'
import {NAVIGATE_OLD} from '../actions/navigation'
import {PLACE_ORDER_OLD, UPDATE_ORDER_OLD} from '../actions/placed-order'
import {RESERVE_TICKETS_OLD} from '../actions/reservation'
import {SEND_RSVP_OLD} from '../actions/rsvp'
import {PendingRequestsOld} from '../types/state'

const defaultState: PendingRequestsOld = {
  requestNames: [],
}

export const pendingRequestsOld = (state: PendingRequestsOld = defaultState, action: AnyAction) => {
  const monitorRequests = [RESERVE_TICKETS_OLD, SEND_RSVP_OLD, PLACE_ORDER_OLD, NAVIGATE_OLD, UPDATE_ORDER_OLD]

  const actionType = monitorRequests.find(type => [type.REQUEST, type.SUCCESS, type.FAILURE].includes(action.type))

  if (!actionType) {
    return state
  }

  if (actionType.REQUEST === action.type) {
    return markRequestPending(state, actionType.REQUEST)
  }

  return markRequestCompleted(state, actionType.REQUEST)
}

const markRequestPending = (state: PendingRequestsOld, name: string) => ({
  ...state,
  requestNames: [...state.requestNames, name],
})

const markRequestCompleted = (state: PendingRequestsOld, name: string) => ({
  ...state,
  requestNames: state.requestNames.filter(testName => testName !== name),
})
